<template>
    <div class="detail">
        <Modal
            v-model="showBankNumModal"
            title="修改银行卡"
            @on-ok="postBankNum"
            @on-cancel="showBankNumModal=false"
        >
            <div class="tit">{{$t('userView.bankName')}}</div>
            <Input v-model="serverData.open_bank"></Input>
            <div class="tit" style="margin-top:10px">({{$t('userView.bankNumber')}}{{serverData.banK_num_init +')'}}</div>
            <Input v-model="serverData.banK_num"></Input>
        </Modal>

        <div class="info_item">
            <div class="info_tit">{{$t('userView.baseInfo')}}</div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('mobile')}}/{{$t('username')}}</div>
                    <div class="info">{{serverData.mobile}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.cname')}}</div>
                    <div class="info">{{serverData.real_name}}</div>
                </div>
                <div class="item">
                    <div class="tit">{{$t('userView.identity')}}</div>
                    <div class="info">{{serverData.id_card_num}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.area')}}</div>
                    <div class="info">{{serverData.now_address}}</div>
                </div>
                <div class="item">
                    <div class="tit">{{$t('userView.address')}}</div>
                    <div class="info">{{serverData.now_detail_address}}</div>
                </div>
            </div>
             <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('password')}}</div>
                    <div class="info">{{serverData.text_pwd}}</div>
                </div>

            </div>
        </div>
        <div class="info_item">
            <div class="info_tit">{{$t('userView.identityPhoto')}}</div>
            <div class="item_row">
                <div class="id_img" @click="big_img = $ht_ip+serverData.id_card_front_img;show_big_img = true">
                    <img :src="$ht_ip+serverData.id_card_front_img" alt />
                    <div>{{$t('userView.identityFront')}}</div>
                </div>
                <div class="id_img" @click="big_img = $ht_ip+serverData.id_card_back_img;show_big_img = true">
                    <img :src="$ht_ip+serverData.id_card_back_img" alt />
                    <div>{{$t('userView.identityBack')}}</div>
                </div>
                <div class="id_img" @click="big_img = $ht_ip+serverData.id_hold_card_img;show_big_img = true">
                    <img :src="$ht_ip+serverData.id_hold_card_img" alt />
                    <div>{{$t('userView.identityHand')}}</div>
                </div>
            </div>
        </div>
<!--         <div class="info_item">
            <div class="info_tit">支付宝信息</div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">支付宝账号</div>
                    <div class="info">{{serverData.alipay_account}}</div>
                </div>
                <div class="item">
                    <div class="tit">芝麻信用分</div>
                    <div class="info">{{serverData.zhima_point}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">学历</div>
                    <div class="info">{{serverData.degree}}</div>
                </div>
                <div class="item">
                    <div class="tit">是否芝麻验证</div>
                    <div class="info">{{serverData.is_auth_alipay}}</div>
                </div>
            </div>
        </div>
 -->        <div class="info_item">
            <div class="info_tit">{{$t('userView.companyInfo')}}</div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.companyName')}}</div>
                    <div class="info">{{serverData.company_name}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.companyAddress')}}</div>
                    <div class="info">{{serverData.company_address}}</div>
                </div>
                <div class="item">
                    <div class="tit">{{$t('userView.address')}}</div>
                    <div class="info">{{serverData.detail_address}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.jobPosition')}}</div>
                    <div class="info">{{serverData.job_position}}</div>
                </div>
                <div class="item">
                    <div class="tit">{{$t('userView.workYear')}}</div>
                    <div class="info">{{serverData.work_year}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.companyPhone')}}</div>
                    <div class="info">{{serverData.company_telnum}}</div>
                </div>
                <div class="item">
                    <div class="tit">{{$t('userView.salary')}}</div>
                    <div class="info">{{serverData.salary}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.contact')}}</div>
                    <div class="info">{{serverData.direct_relatives_name}}</div>
                </div>
                <div class="item">
                    <div class="tit">{{$t('userView.contactRelation')}}</div>
                    <div class="info">{{serverData.direct_relationship}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.contactPhone')}}</div>
                    <div class="info">{{serverData.direct_relatives_mobile}}</div>
                </div>
            </div>
        </div>
        <div class="info_item">
            <div class="info_tit">{{$t('userView.bankNumberInfo')}}</div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.bankName')}}</div>
                    <div class="info">{{serverData.open_bank}}</div>
                </div>
            </div>
            <div class="item_row">
                <div class="item">
                    <div class="tit">{{$t('userView.bankNumber')}}</div>
                    <div class="info">{{serverData.banK_num}}</div>
                </div>
                <div class="item">
                    <Button type="primary" size="small" @click="showBankNumModal=true">{{$t('edit')}}{{$t('userView.bankNumber')}}</Button>
                </div>
            </div>
        </div>
        <Modal v-model="show_big_img" :title="$t('viewBigPotho')" width="600" @on-ok="big_img = ''">
            <img class="big_img" :src="big_img" alt />
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showBankNumModal: false,
            serverData: {},
            big_img: "",
            show_big_img: false
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$get(this.$path.user_det, this.$route.query).then(res => {
                if (res.data) {
                    this.serverData = res.data;
                } else {
                    this.$Message.info(this.$i18n.t('dataFailed'));
                }
            });
        },
        postBankNum() {
            this.$post(this.$path.user_edit, {
                user_id: this.$route.query.user_id,
                banK_num: this.serverData.banK_num,
                open_bank: this.serverData.open_bank
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                } else {
                    this.$Message.error("this.$i18n.t('operateFailed')");
                }
                this.loadData();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.detail {
    .info_item {
        border-bottom: 1px #eeeeee solid;
        padding-bottom: 15px;
        .info_tit {
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .item_row {
            display: flex;
            flex-direction: row;
            margin-bottom: 5px;
            .item {
                display: flex;
                flex-direction: row;
                .tit {
                    width: 100px;
                    color: #bab9b9;
                }
                .info {
                    width: 200px;
                }
            }
            .id_img {
                width: 200px;
                margin-right: 20px;
                img {
                    width: 200px;
                    height: 130px;
                }
                div {
                    width: 100%;
                    text-align: center;
                    color: #bab9b9;
                }
            }
        }
    }
    .info_item:nth-child(1) {
        margin-bottom: 15px;
    }
    .info_item:nth-child(n + 2) {
        margin: 15px 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/user/detail.vue